module.exports = __webpack_public_path__ + "static/media/image6.c3226790.png";